import React from 'react';
import Header from './components/Header10';
import Footer from './components/Footer10';

const PrivacyPolicy10 = () => {
    const sections = [
        {
            title: '1. Information We Collect',
            content: 'We collect information that you provide directly to us, including your name, email address, postal address, phone number, and payment information when you make a purchase, create an account, or subscribe to our newsletter. We also automatically collect certain information about your device when you use our website.',
        },
        {
            title: '2. How We Use Your Information',
            content: 'We use the information we collect to process your orders, communicate with you about your purchases, send you marketing communications (with your consent), improve our website and services, prevent fraud, and comply with legal obligations.',
        },
        {
            title: '3. Information Sharing',
            content: 'We do not sell, trade, or rent your personal information to third parties. We may share your information with service providers who assist us in operating our website, such as payment processors and shipping carriers. These third parties are obligated to keep your information confidential.',
        },
        {
            title: '4. Data Security',
            content: 'We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.',
        },
        {
            title: '5. Cookies',
            content: 'We use cookies and similar technologies to enhance your browsing experience, analyse site traffic, and personalise content. You can control cookie settings through your browser preferences.',
        },
        {
            title: '6. Your Rights',
            content: 'You have the right to access, correct, or delete your personal information. You may also opt out of marketing communications at any time. To exercise these rights, please contact us at the details provided below.',
        },
        {
            title: '7. Data Retention',
            content: 'We retain your personal information for as long as your account is active or as needed to provide you services. We will retain and use your information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements.',
        },
        {
            title: '8. Changes to This Policy',
            content: 'We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page. You are advised to review this page periodically for any changes.',
        },
        {
            title: '9. Contact Us',
            content: 'If you have any questions about this Privacy Policy, please contact us at hello@sthir.in or through our Contact page.',
        },
    ];

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px]">
                    {/* Page Header */}
                    <div className="py-12 md:py-20 px-5 md:px-8 text-center" style={{ borderBottom: '1px solid #E7E5E4' }}>
                        <h1 className="text-2xl md:text-4xl font-light text-[#1C1917] tracking-tight">Privacy Policy</h1>
                        <p className="text-[#A8A29E] text-xs font-light mt-3">Last updated: March 2026</p>
                    </div>

                    <div className="max-w-[700px] mx-auto px-5 md:px-8 py-10 md:py-16">
                        <div className="space-y-10">
                            {sections.map((section, index) => (
                                <div key={index}>
                                    <h2 className="text-[#1C1917] text-sm font-normal tracking-wider mb-3">{section.title}</h2>
                                    <p className="text-[#78716C] text-sm font-light leading-[1.8]">{section.content}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default PrivacyPolicy10;
